import React,{useState,useEffect,useContext} from 'react';
import { Container,Row } from 'react-bootstrap';
import { TabNavigation } from '../../Components/TabNavigation/TabNavigation';
import { Avanzado } from './Avanzado';
import { MisAgentes } from './MisAgentes';
import { MisGrupos } from './MisGrupos';
import { MisOficinas } from './MisOficinas';
import { MisUsuarios } from './MisUsuarios';
import { MiFormularioAgentes } from './MiFormularioAgentes';
import { AuthContext } from '../../auth/AuthContext';
import {
  BrowserRouter as Router,
  Redirect,
  useHistory,
} from "react-router-dom";

export const Configuracion = ({initState,updateState}) => {
  let history = useHistory();
  const { usuario } = useContext(AuthContext)
  const {openMenu} = initState;
  const [viewTab,setViewTab] = useState(0);
  const [dataOficinas,setDataOficinas] = useState([]);
  const [loadOficinas,setLoadOficinas] = useState(true);
  const [dataGrupos,setDataGrupos] = useState([]);
  const [loadGrupos,setLoadGrupos] = useState(true);
  const [dataUsuarios,setDataUsuarios] = useState([]);
  const [loadUsuarios,setLoadUsuarios] = useState(true);
  const [dataAgentes,setDataAgentes] = useState([]);
  const [loadAgentes,setLoadAgentes] = useState(true);
  const [dataGerentes,setDataGerentes] = useState([]);
  const [loadGerentes,setLoadGerentes] = useState(true);
  const [dataEjecutivos,setDataEjecutivos] = useState([]);
  const [loadEjecutivos,setLoadEjecutivos] = useState(true);
  const [dataFormularios,setDataFormularios] = useState([]);
  const [loadFormularios,setLoadFormularios] = useState(true);
  const [dataTab,setDataTab] = useState([
    {
      name : 'Mis grupos',
      onClick : (e) => {
        setViewTab(0)
      },
    },
    {
      name : 'Mis oficinas',
      onClick : (e) => {
        setViewTab(1)
      },
    },
    {
      name : 'Mis agentes',
      onClick : (e) => {
        setViewTab(2)
      },
    },
    {
      name : 'Mi formulario de agentes',
      onClick : (e) => {
        setViewTab(3)
      },
    },
    {
      name : 'Mis usuarios',
      onClick : (e) => {
        setViewTab(4)
      },
    },
    {
      name : 'Avanzado',
      onClick : (e) => {
        setViewTab(5)
      },
    }
  ])

  useEffect(() => {
    getConfigFichaAgentes()
    getConfiguracionesOficinas()
    getConfiguracionesGrupos()
    getAllUsuarios()
    getAllAgentes()
    getListaGerentes()
    getListaEjecutivos()
  }, [])

  const { nombre,tipo } = usuario;

  if(tipo=='3' || tipo=='2'){
    history.replace("/agentes");
    return false;
  }

  return (
    <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
      <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
        <TabNavigation data={dataTab} />
        <Container fluid>
          <Row>
            {
              (viewTab===0) ?
                <MisGrupos initState={initState} updateState={updateState} data={dataGrupos} load={loadGrupos} reload={getConfiguracionesGrupos} />
              : (viewTab===1) ?
                <MisOficinas initState={initState} updateState={updateState} data={dataOficinas} load={loadOficinas} reload={getConfiguracionesOficinas} />
              : (viewTab===2) ?
                <MisAgentes initState={initState} updateState={updateState} data={dataAgentes} setData={setDataAgentes} load={loadAgentes} reload={getAllAgentes} />
              : (viewTab===3) ?
                <MiFormularioAgentes 
                initState={initState} 
                updateState={updateState} 
                data={dataFormularios}
                setData={setDataFormularios}
                updateStatusFichaAgente={updateStatusFichaAgente}
                />
              : (viewTab===4) ?
                <MisUsuarios initState={initState} updateState={updateState} data={dataUsuarios} load={loadUsuarios} reload={getAllUsuarios} />
              : (viewTab===5) ?
                <Avanzado 
                initState={initState} 
                updateState={updateState} 
                dataGerentes={dataGerentes}
                setDataGerentes={setDataGerentes} 
                loadGerentes={loadGerentes} 
                reloadGerentes={getListaGerentes} 
                dataEjecutivos={dataEjecutivos} 
                setDataEjecutivos={setDataEjecutivos}
                loadEjecutivos={loadEjecutivos} 
                reloadEjecutivos={getListaEjecutivos} 
                />
              : null
            }
          </Row>
        </Container>
      </div>
    </div>
  )
  /*------------------------------------------------------------------------------------------*/

  function getConfigFichaAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
    }
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getConfigFichaAgentes`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
    .then(res => res.json())
    .then((res) => {
      setDataFormularios(res.list)
    })
  }

  function updateStatusFichaAgente(id_padre,status) {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_padre,
      status
    }
    console.log(dataSend)
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateStatusFichaAgente`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
    .then(res => res.json())
    .then((res) => {
      console.log(res)
    })
  }

  /*------------------------------------------------------------------------------------------*/


  function getConfiguracionesOficinas() {
    const dataSend = {
      id_login: usuario.id_usuario,
    }
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getConfiguracionesOficinas`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
    .then(res => res.json())
    .then((res) => {
      setDataOficinas(res.list)
      setLoadOficinas(false)
    })
  }

  function getConfiguracionesGrupos() {
    const dataSend = {
      id_login: usuario.id_usuario,
    }
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getConfiguracionesGrupos`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
    .then(res => res.json())
    .then((res) => {
      setDataGrupos(res.list);
      setLoadGrupos(false);
    })
  }

  function getAllUsuarios() {
    const dataSend = {
      id_login: usuario.id_usuario,
    }
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAllUsuarios`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
    .then(res => res.json())
    .then((res) => {
      setDataUsuarios(res.list)
      setLoadUsuarios(false)
    })
  }

  function getAllAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: '',
      oficinas: '',
      agentes: '',
      tipo_agente: ''
    }
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAllAgentes`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
      .then(res => res.json())
      .then((res) => {
        setDataAgentes(res.list)
        setLoadAgentes(false)
      })
  }

  function getListaGerentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
    }
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getListaGerentes`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
      .then(res => res.json())
      .then((res) => {
        setDataGerentes(res.list)
        setLoadGerentes(false)
      })
  }

  function getListaEjecutivos() {
    const dataSend = {
      id_login: usuario.id_usuario,
    }
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getListaEjecutivos`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
      .then(res => res.json())
      .then((res) => {
        setDataEjecutivos(res.list)
        setLoadEjecutivos(false)
      })
  }

}